import { AbortManager } from './query/abortManager';
import { Instance } from 'types';

export interface State {
	initialized: boolean; // Whether the library has been initialized
	isActive: boolean; // Whether search functionality is active
	overriddenElements: Set<HTMLElement>; // Set of forms that have been modified
	currentQuery: string; // Current search query
	currentInstance: Instance | null; // Current instance of the search
	currentAudio: HTMLAudioElement | null; // Current audio for readAloud
	mediaRecorder: MediaRecorder | null; // Audio recording interface
	isRecording: boolean; // Whether audio is being recorded
	audioFileExtension: string; // File extension for recorded audio
	audioChunks: Blob[]; // Recorded audio data chunks
	activeQueryId: string | null; // Track the currently active query
	abortManager: AbortManager // Global abort manager
}

const state: State = {
	initialized: false,
	isActive: false,
	overriddenElements: new Set<HTMLElement>(),
	currentQuery: '',
	currentInstance: null,
	currentAudio: null,
	mediaRecorder: null,
	isRecording: false,
	audioFileExtension: '',
	audioChunks: [],
	activeQueryId: null,
	abortManager: new AbortManager(),
};

export default state;
